// Volt Fleet theme JS
(function(){
  var mt = document.querySelector('[data-menu-toggle]');
  if (mt) mt.addEventListener('click', function(){
    var n = document.getElementById('MobileNav'); if (n) n.classList.toggle('open');
  });
  document.querySelectorAll('.product__thumbs [data-full]').forEach(function(t){
    t.addEventListener('click', function(){
      var g = this.closest('.product__gallery');
      var m = g ? g.querySelector('.main img') : null;
      if (m) m.src = this.getAttribute('data-full');
      if (g) g.querySelectorAll('.product__thumbs .ph').forEach(function(p){ p.classList.remove('sel'); });
      this.classList.add('sel');
    });
  });
  document.querySelectorAll('.qty').forEach(function(q){
    var input = q.querySelector('input');
    var span = q.querySelector('span');
    var btns = q.querySelectorAll('button');
    function val(){ return parseInt((input?input.value:span.textContent)||'1',10)||1; }
    function set(v){ v=Math.max(1,v); if(input) input.value=v; if(span) span.textContent=v; }
    if(btns[0]) btns[0].addEventListener('click', function(e){ e.preventDefault(); set(val()-1); });
    if(btns[1]) btns[1].addEventListener('click', function(e){ e.preventDefault(); set(val()+1); });
  });
})();
